import { CalendarDays } from 'lucide-preact'

interface CalendarHeaderProps {
  eventCount: number
}

export function CalendarHeader({ eventCount }: CalendarHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-3">
          <CalendarDays className="w-7 h-7 text-primary-600" />
          Calendar
        </h1>
        <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
          View and manage your campaign touchpoints and events
        </p>
      </div>
      <div className="text-sm text-slate-600 dark:text-slate-400">
        <span className="font-medium">{eventCount}</span> event{eventCount !== 1 ? 's' : ''}
      </div>
    </div>
  )
}
